import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import * as tslib_1 from "tslib";
import { NoPassLoginStartUrl, NoPassLoginFinishUrl, NoPassListDevicesURL, NoPassDeleteDeviceURL } from '../constants';
var RequestHeaders = {
  headers: {
    Accept: 'application/json'
  }
};
export function nopass(api) {
  var _this = this;

  return {
    loginStart: function loginStart(username) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return api.post("".concat(NoPassLoginStartUrl, "?username=").concat(username), {}, RequestHeaders);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    loginFinish: function loginFinish(authId) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api.get(NoPassLoginFinishUrl, {
                  authid: authId
                }, RequestHeaders));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    },
    getDevices: function getDevices() {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", api.authenticated().get(NoPassListDevicesURL, {}, RequestHeaders));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    },
    deleteDevice: function deleteDevice(deviceId) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", api.authenticated().post(NoPassDeleteDeviceURL(deviceId), {}, RequestHeaders));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    },
    getAuthHistory: function getAuthHistory() {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", api.authenticated().get(NoPassListDevicesURL, {}, RequestHeaders));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  };
}